var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"tool-block",attrs:{"to":_vm.blockLink}},[_c('InlineSvg',{staticClass:"tool-block__svg",attrs:{"src":require(`../../assets/svgs/${_vm.svg}.svg`)}}),_c('p',{staticClass:"body-copy body-copy--align-center",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }